/**
 * Sales API
 *
 * @author minkyoung.park@emcast.com
 */
import httpService from "@/api/httpService";

const boardApi = {
  // 요청(Request)
  // https://dev.clp.kr/spc/api/static/docs/front_board.html#resources-front-board-bbs-fetch-list_request_parameters
  navigationList() {
    return httpService.get(`/board/bbs`);
  },

  // 목록-페이징(list-paging)
  // https://dev.clp.kr/spc/api/static/docs/article_bbs_main.html#resources-board-article-bbs-fetch
  fetchList(params,boardId) {
    return httpService.get(`/board/${boardId}/article`, params);
  },

  // https://dev.clp.kr/spc/api/static/docs/article_bbs_main.html#resources-board-article-bbs-fixlist
  fetchFixList(boardId) {
    return httpService.get(`/board/${boardId}/article/fix/list`);
  },

  // 요청(Request)
  // https://dev.clp.kr/spc/api/static/docs/front_board.html#resources-front-board-bbs-fetch-list_http_request
  boardAuth(params){
    return httpService.get(`/board/${params.boardId}/auth`);
  },

  // 상세(Detail)
  // https://dev.clp.kr/spc/api/static/docs/article_bbs_main.html#resources-board-article-bbs-detail_http_request
  boardDetails(params) {
    return httpService.get(`/board/${params.boardId}/article/${params.postId}`);
  },

  // upload image and video
  upload(file) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("isUnzip", false);
    return httpService.post("/common/attachment", formData)
  },

  // list all comment under a post
  // http://54.251.23.221:8080/static/docs/article_comment.html#resources-board-article-fetch
  listComments(postParams, params) {
    //console.log('dasssssssssss',articleId)
    return httpService.get(`/board/${postParams.boardId}/article/${postParams.postId}/comment`, params);
  },

  // add comment under a post
  commentPost(params,commentvalue) {
    return httpService.post(`/board/${params.boardId}/article/${params.postId}/comment`, commentvalue);
    //return httpService.post(`/board/SNS1/article/${articleId}/comment`, params);
  },

   // Edit comment under a post
   commentEdit(params, editCommentValue,id) {
    return httpService.put(`/board/${params.boardId}/article/${params.postId}/comment/${id}`, editCommentValue);
  },

  // 2Level Reply Comment
  postReply(params, originId, replyValue) {
    return httpService.post(`/board/${params.boardId}/article/${params.postId}/comment/${originId}`, replyValue)
  },

   // 2Level Reply Edit Comment
  editReply(params,replyEditId,replyEditValue) {
    return httpService.put(`/board/${params.boardId}/article/${params.postId}/comment/${replyEditId}`, replyEditValue)
  },

  // 1Level OR 2Level Comment Report
  reportComment(params) {
    return httpService.post(`/board/${params.boardId}/article/${params.postId}/comment/${params.id}/report`, params)
  },

  // 1Level OR 2Level Comment Delete
  deleteComment(params, id) {
    return httpService.delete(`/board/${params.boardId}/article/${params.postId}/comment/${id}`)
  },

  /**
   *
   * @param {object} params params.boardId 게시판 아이디 params.postId 포스트 아이디
   * @returns {Promise<AxiosResponse<any>>}
   */
  reportPost(params) {
    return httpService.post(`/board/${params.boardId}/article/${params.postId}/report`, params)
  },

  // delete post
  deletePost(params) {
    return httpService.delete(`/board/${params.boardId}/article/${params.postId}`)
  },

  // get Category List for post
  fetchCategoryList(params) {
    return httpService.get(`/board/info/${params.boardId}`)
  },

  //http://54.251.23.221:8080/static/docs/account.html#resources-account-fetch-info
  fetchMember(params) {
    return httpService.get(`/membership/member`, params);
    // return httpService.get(`/board/SNS1/article/list`,params)
  },

  searchTags(str) {
    return httpService.get(`/common/tag/search?name=${str}`);
  },

  createTags(str) {
    return httpService.post(`/common/tag`,str);
  },

  // Add post
  // https://clpapi.tinkeredu.co.kr/static/docs/article_main.html#resources-board-article-register
  register(params,boardId) {
    return httpService.post(`/board/${boardId}/article`, params);
  },


  updatePost(id, params,boardId) {
    return httpService.put(`/board/${boardId}/article/${id}`, params);
    //return httpService.put(`/board/SNS1/article/${id}`, params);
  },



};

// export const
export default boardApi;
